import { AbstractControl } from '@angular/forms';
import { FormGroup, FormControl, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { BaseDataService } from './../../base-services/base-data.service';
import { AuthenticationService } from './../../base-services/authentication.service';
import { ChangeDetectionStrategy, Component, AfterViewInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MakeProvider, AbstractCustomControl } from '../abstract-custom-control';
import { Router } from '@angular/router';
import { InputComponent } from '../input/input/input.component';
import { EmailExistenceValidator } from '../../validators/email-existence-validator';
@Component({
    selector: 'yt-register',
    templateUrl: './register.component.html',
    providers: [ MakeProvider(RegisterComponent) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterComponent implements AfterViewInit {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private baseDataService: BaseDataService,
        private changeDetectorRef: ChangeDetectorRef
    ){
    }
    
    loginFormGroup: FormGroup = new FormGroup({
        Username: new FormControl('', Validators.required),
        Password: new FormControl('', Validators.required)
    });

    registerFormGroup: FormGroup = new FormGroup({
        FirstName: new FormControl('', Validators.required),
        LastName: new FormControl('', Validators.required),
        //CompanyName: new FormControl('', Validators.required),
        City: new FormControl(null, Validators.required),
        Phone: new FormControl('', Validators.required),
        Email: new FormControl('', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')], EmailExistenceValidator.createValidator(this.baseDataService)),
        RegisterPassword: new FormControl('', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&\.]).{8,}')]),
        RegisterPasswordConfirm: new FormControl('', Validators.required
        //, [Validators.required, CheckPassword(this.registerFormGroup)]
        )
    }, { validators: CheckPassword });

    loginSubmitted: boolean = false;
    registerSubmitted: boolean = false;
    registrationBoxVisible: boolean = false;
    loggingIn: boolean = false;

    showRegistrationButton: boolean = true;
    showForgottenPasswordButton: boolean = true;

    showStatus: boolean = false;
    statusText: string = '';

    @ViewChild('username', { static: true }) username: InputComponent;
    @ViewChild('firstName', { static: false }) firstName: InputComponent;

    ngAfterViewInit(){
        setTimeout(() => {
            if(this.username)
                this.username.focus();
        }, 100);
    }
    
    Login(username, password){
        this.loginSubmitted = true;
        //this.loggingIn = true;
        if(this.loginFormGroup.valid){
            this.loggingIn = true;
            this.authenticationService.Login(username, password)
                .subscribe(data => {
                    this.router.navigate(['company-selector']);
                },
                (error) => {
                    //console.log('login error');
                    //console.log(error);
                    //alert(error.error.error_description);
                    this.showStatus = true;
                    this.statusText = 'FW.ERRORS.' + (error.error.error == 'invalid_grant' ? 'INVALID-GRANT' : 'ERROR');
                    this.loggingIn = false;
                    this.changeDetectorRef.markForCheck();
                    //throw error;
                })
        }
    }

    Register(firstName, lastName, city, phone, email, password, passwordConfirm){
        this.registerSubmitted = true;
            if(this.registerFormGroup.valid && !this.registerFormGroup.pending){
            let parameters = {
                // registerCompany: {
                //     CompanyName: companyName,
                //     MestoID: city,
                //     Phone: phone,
                //     Email: email
                // },
                //registerUser: {
                    FirstName: firstName,
                    LastName: lastName,
                    Email: email,
                    Password: password,
                    //CompanyID: -1
                    Phone: phone
                //}
            };
            this.baseDataService.GetData('registration', 'register', parameters)
                .subscribe(data => {
                    this.router.navigate(['/korisnicki-nalog-kreiran']);
                });
            }
    }

    showRegistrationBox(){
        this.registrationBoxVisible = !this.registrationBoxVisible;
        if(this.registrationBoxVisible) {
            setTimeout(() => {
                this.firstName.focus();
            }, 100);
        }
    }

    
}

export function CheckPassword(group: FormGroup): ValidationErrors {
    //return (control: AbstractControl): ValidationErrors | null => {
        if(!group || !group.get('RegisterPassword') || !group.get('RegisterPasswordConfirm'))
            return null;
        let password = group.get('RegisterPassword').value;
        let confirmPassword = group.get('RegisterPasswordConfirm').value;
        return password === confirmPassword ? null : { notSame: true };
    //}
}